import {AnimationService} from "../service/animation";
import OpenAccordion from "../animations/open-accordion";
import CloseAccordion from "../animations/close-accordion";

export class ProductFiltersComponent
{
    private $root:JQuery;
    private $toggle:JQuery;
    private $content:JQuery;
    private animations:AnimationService;

    constructor(element:HTMLElement) {
        this.$root = $(element);
        this.$toggle = $(element).find('.js-product-filters__toggle');
        this.$content = $(element).find('.js-product-filters__content');
    }

    protected init() {
        this.$toggle.on({ click: this.toggleFilters });
    }

    protected toggleFilters = (ev:MouseEvent) => {
        if ('true' === this.$root.attr('aria-expanded')) {
            this.handleFiltersClose();
        } else {
            this.handlFiltersOpen();
        }
    }

    protected handlFiltersOpen = () => {
        this.$toggle.attr('aria-expanded', 'true');
        this.$root.attr('aria-expanded', 'true')
        this.animations.run(OpenAccordion, this.$content);
    }

    protected handleFiltersClose = () => {
        this.$toggle.attr('aria-expanded', 'false');
        this.$root.attr('aria-expanded', 'false')
        this.animations.run(CloseAccordion, this.$content);
    }

    public setAnimationHandler(animations:AnimationService) {
        this.animations = animations;
        return this;
    }
}